import React from 'react';
import { FlexGrid, Link, Typography, getClassNameFactory } from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography/TypographyTypes';
import { IFrequentlyAskedQuestionProps } from '../FrequentlyAskedQuestionsTypes';
import { useMobile } from '../../../utils/customHooks/useMobile';
import { getDescription } from '../Utils';
import '../index.css';

const FrequentlyAskedQuestionItem = ({
  title,
  link,
  description,
}: IFrequentlyAskedQuestionProps): React.ReactElement => {
  const { isMobile } = useMobile();
  const getClassName = getClassNameFactory(
    FrequentlyAskedQuestionItem.displayName
  );

  return (
    <FlexGrid.Col className={getClassName({ descendantName: 'wrapper' })}>
      <Typography className={getClassName({ descendantName: 'linkWrapper' })}>
        <Link href={link}>{title}</Link>
      </Typography>
      <div className={getClassName({ descendantName: 'typographyWrapper' })}>
        <Typography
          tag={TypographyTags.P}
          className={getClassName({ descendantName: 'description' })}
        >
          {getDescription(description, isMobile)}
        </Typography>
      </div>
    </FlexGrid.Col>
  );
};

FrequentlyAskedQuestionItem.displayName = 'FrequentlyAskedQuestionItem';

export default FrequentlyAskedQuestionItem;
